export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_10.42c01b6f.png";